<template>
  <div class="container">
    <div class="options">
      <a-space>
        <a-button type="primary" icon="plus" @click="handleAdd"
          >添加余额表映射模版</a-button>
      </a-space>
    </div>


    <a-table
      :columns="columns"
      :data-source="data"
      :row-selection="rowSelection"
      :loading="loading"
      :pagination="{ current: current, pageSize: pageSize, total: total }"
      @change="handleTableChange"
    >
      <a
        slot="realname"
        slot-scope="realname, record"
        @click="handleShow(record)"
      >
        {{ realname }}
      </a>
      <span slot="agentRole" slot-scope="agentRole">
        {{
          roleList.filter((item) => item.id == agentRole)[0]
            ? roleList.filter((item) => item.id == agentRole)[0].name
            : "-"
        }}
      </span>
      <span slot="status" slot-scope="status">
        <a-tag :key="status" :color="status == '1' ? 'green' : 'red'">
          {{ statusFormatter(status) }}
        </a-tag>
      </span>
      <span slot="createTime" slot-scope="createTime">
        {{ $moment(createTime).format("YYYY-MM-DD") }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record.id)">删除</a>
      </span>
    </a-table>
    <softWareMap-modal ref="softWareMapModal" @reload="queryList" />
  </div>
</template>
<script>
import softWareMapModal from "./components/softWareMapModal";
import {
  querySoftWareMapList,
  deleteSoftWareMap,
} from "@/api/softmap";
export default {
  name: "user",
  data() {
    return {
      loading: false,
      data: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "财务软件名称",
          dataIndex: "softwareName",
          key: "softwareName",
        },
        {
          title: "企业科目编码",
          dataIndex: "destSubNo",
          key: "destSubNo",
        },
        {
          title: "企业科目名称",
          dataIndex: "destSubName",
          key: "destSubName",
        },
        // {
        //   title: "企业期初余额-方向",
        //   dataIndex: "dOpenType",
        //   key: "dOpenType",
        // },
        {
          title: "企业期初余额",
          dataIndex: "destOpenBal",
          key: "destOpenBal",
        },
        {
          title: "企业本期借方",
          dataIndex: "destCurrentDebit",
          key: "destCurrentDebit",
        },
        {
          title: "企业本期贷方",
          dataIndex: "destCurrentCredit",
          key: "destCurrentCredit",
        },
        // {
        //   title: "企业期末余额-方向",
        //   dataIndex: "dEndType",
        //   key: "dEndType",
        // },
        {
          title: "企业期末余额",
          dataIndex: "destEndBal",
          key: "destEndBal",
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      current: 1,
      pageSize: 10,
      total: 0,
      roleList: [],
      selectedRowKeys: [],
      selectedRows: [],
    };
  },
  components: { softWareMapModal},
  async created() {
    await this.queryList();
  },
  methods: {
    statusFormatter(status) {
      if (status == 1) {
        return "启用";
      } else {
        return "禁用";
      }
    },
    async queryList() {
      this.loading = true;
      let res = await querySoftWareMapList({
        page: this.current,
        pageSize: this.pageSize,
      });
      if (res.status == 200) {
        this.data = res.data.rows;
        this.total = res.data.records;
      } else {
        let msg = res.msg || res.message;
        let len = msg.length;
        this.$notification.error({
          message: "系统提示",
          description: len > 100 ? "系统错误，请联系管理员" : msg,
          duration: 4,
        });
      }
      this.loading = false;
    },
    handleDelete(id) {
      const that = this;
      this.$confirm({
        title: "确认删除",
        content: "是否删除当前数据?",
        onOk: async function () {
          let res = await deleteSoftWareMap({ id: id });
          if (res.status == 200) {
            that.$message.success("删除成功");
            that.queryList();
          } else {
            that.$notification.error({
              message: "系统提示",
              description: res.msg || res.message,
              duration: 4,
            });
          }
        },
      });
    },
    handleShow(record) {
      this.$refs.softWareMapModal.show(1, record);
    },
    handleAdd() {
      this.$refs.softWareMapModal.show(2);
    },
    handleEdit(record) {
      this.$refs.softWareMapModal.show(3, record);
    },


    handleTableChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.total = pagination.total;
      this.queryList();
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows;
        },
      };
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-tag {
  margin: 0;
}
.container {
  padding: 20px;
  background: #fff;
  min-height: 280px;
}
.options {
  padding-bottom: 16px;
}
</style>
